export default "__VITE_ASSET__5c83be9d__"